import { CloseIcon } from '../../../assets/icons/Svg'
import { selectPopulatePackageItem } from '../../../features/client/clientSlice';
import { useDispatch, useSelector } from 'react-redux';
import { clearTypeOfThirdModal } from '../../../features/modal/modalSlice';
import { PRODUCT_SIZE } from '../../../constant/constant';

export default function ViewSelectedSpecialProduct() {

    const specialPackageItem = useSelector(selectPopulatePackageItem);
    const dispatch = useDispatch()

    return (
        <div className="fixed inset-0 m-0 p-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[102] overflow-hidden">
            <div className="relative w-[90vw] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75vw] lg:max-w-[60vw] lg:mx-auto overflow-hidden">
                <div className="flex flex-col w-full min-h-[50dvh] max-h-[80dvh] overflow-hidden">
                    <div className="flex flex-col py-5 space-y-3 h-full">
                        <div className="flex justify-between items-center py-1">
                            <div>
                                <p className="text-sm font-semibold leading-tight text-slate-900">
                                    Selected Products
                                </p>
                                <p className="text-sm text-slate-500 mt-1">
                                    Review the products you've selected before proceeding.
                                </p>
                            </div>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                                onClick={() => dispatch(clearTypeOfThirdModal())}
                            >
                                <CloseIcon />
                            </button>
                        </div>
                        <div className='px-2 bg-gray-200 rounded py-1.5 mb-2'>
                            <div className='grid grid-cols-12 gap-2 w-full text-[12px] items-center'>
                                <p className='col-span-4'>Name</p>
                                <p className='col-span-2'>Temperature</p>
                                <p className='col-span-2'>Size</p>
                                <p className='col-span-2'>Price</p>
                                <p className='col-span-2'>Addons</p>
                            </div>
                        </div>
                        <div className='overflow-hidden h-full rounded'>
                            <div className="h-full overflow-y-auto rounded">
                                <div className="pr-1 h-full rounded overflow-y-auto ">
                                    <div className="grid grid-cols-1 gap-2">
                                        {specialPackageItem?.map((prod) => {
                                            const addons = prod.addons ?? []
                                            const prodType = prod?.typeName.toLowerCase() === PRODUCT_SIZE.sNone.name.toLowerCase() ? '' : prod?.typeName
                                            const sizeName = prod.size.toLowerCase() === PRODUCT_SIZE.sNone.name.toLowerCase() ? '' : prod.size
                                            return (
                                                <div key={prod.productID} className={`cursor-pointer transition-colors rounded`}>
                                                    <div className="border border-gray-200 flex flex-col p-2.5 space-y-1 rounded bg-gray-100 transition-colors">
                                                        <div className="grid grid-cols-12 gap-2 w-full text-[12px] items-center">
                                                            <div className="col-span-4 font-medium truncate">
                                                                {`${prod?.productName}`}
                                                            </div>
                                                            <div className="col-span-2 truncate">{prodType}</div>
                                                            <div className="col-span-2 truncate">{sizeName}</div>
                                                            <div className="col-span-2 truncate">{prod.price}</div>
                                                            <div className="col-span-2 mt-1 flex flex-col text-[11px] text-gray-600">
                                                                {addons.map((add) => (
                                                                    <div key={add.addonID}>{add.addonName}</div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
